import { useEffect, useState } from "react";
import { IconHelp } from "@tabler/icons-react";
import "./MobileButtons.scss";
import { Button } from "@mantine/core";
import ClientEmailModal from "../ClientEmailModals/ClientEmailModal/ClientEmailModal";

const MobileButtons = () => {
  const [buttonState, setButtonState] = useState({
    isVisible: false,
    text: "Need help?",
  });

  const [emailModalOpened, setEmailModalOpened] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.matchMedia("(max-width: 700px)").matches) {
        setButtonState({
          isVisible: true,
          text: "",
        });
      } else {
        setButtonState({
          isVisible: false,
          text: "Need help?",
        });
      }
    };

    // Set initial text
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="main">
      <Button
        size="lg"
        className="need-help"
        leftSection={<IconHelp />}
        onClick={() => setEmailModalOpened(true)}
      >
        {buttonState.text}
      </Button>
      <ClientEmailModal
        opened={emailModalOpened}
        onClose={() => setEmailModalOpened(false)}
      />
    </div>
  );
};

export default MobileButtons;
